<div class="isg-full-page-header">

  <div class="isg-page-header pb-home-hdr-layout">
    <span>{{heading()}}</span>
    <app-user-company-droplist *ngIf="showCompanyOthers()"
                               [(companyId)]="currCompanyId"
                               [heading]="'Viewing'"
                               [headingCssClass]="'isg-header-label-company'"
                               [controlWidth]="300"
                               [filterUserGroup]="ctCodeGroupShare"
                               (selected)="onUserCompanySelected($event)">
    </app-user-company-droplist>
  </div>

  <div class="isg-page-body">
    <div class="pb-homepage">

      <!-- Row 1, left column -->
      <app-pb-last-visit-summary class="last-visit-summary"
                                 [filterCompanyId]="currCompanyId()">

      </app-pb-last-visit-summary>

      <!-- Row 2, left column -->
      <app-pb-dashboard-frame class="recent-items"
                              [title]="'Recent Scenarios'"
                              [showHoverOver]="false">
        <button frameAction
                class="frame-link"
                (click)="onViewAllScenarios()">
          View all
          <i class="fa fa-arrow-right"></i>
        </button>

        <app-pb-recent-items [filterCompanyId]="currCompanyId()">
        </app-pb-recent-items>
      </app-pb-dashboard-frame>

      <!--<app-pb-dashboard-frame class="deal-usage"
                              title="My Usage"
                              subtitle="Scenarios Count By Tower (Created in the last 6 months)"
                              [showHoverOver]="false">
        <app-pb-deal-usage>

        </app-pb-deal-usage>

      </app-pb-dashboard-frame>-->
      <!-- Row 2, right column -->
      <app-pb-dashboard-frame class="latest-news"
                              [title]="'Latest News And Publications'"
                              [showHoverOver]="false">
        <!--<app-pb-carousel-vertical></app-pb-carousel-vertical>-->
        <app-pb-news>

        </app-pb-news>
      </app-pb-dashboard-frame>

    </div>

  </div>

</div>
